var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'card bg-white-base border',
		{ 'border-white-darker-4': !_vm.selected, 'border-ink-lighter-3': _vm.selected }
	],style:({ boxShadow: _vm.shadow })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }